import types from '~/modules/user/types';
import dotsTypes from '~/modules/dots/types';
import emailTypes from '~/modules/verify/types';
import * as modes from './modes';
import {modalChange, modalClose, modalCloseVerify} from './actions';

const success = (fn) => (action, ...args) => {
  if (action.pending || action.error) {
    return null;
  }

  return fn(action, ...args);
};

const closePop = (fn) => (action, store, prevState) => fn(action, store, prevState);

const isLoggedIn = (fn) => (action, store, prevState) => {
  if (!store.getState().user.isLoggedIn) {
    return null;
  }

  return fn(action, store, prevState);
};

const isVerified = (fn) => (action, store, prevState) => {
  if (!store.getState().dots.verifyDotMcData.isVerified) {
    return null;
  }

  return fn(action, store, prevState);
};

export default {
  [types.USER_DATA]: [
    success(isLoggedIn(() => modalClose(modes.LOGIN))),
    success(isLoggedIn(() => modalClose(modes.SIGNUP))),
  ],
  [dotsTypes.VERIFY_DOT_MC]: [
    success(isVerified(() => modalCloseVerify(modes.DOT_VALIDATE))),
  ],
  [emailTypes.VERIFY_EMAIL]: [
    closePop(() => modalClose(modes.EMAIL_VALIDATE)),
  ],
  [types.RESET_PASSWORD]: [success(() => modalChange(modes.RESET_PASSWORD_OK, true))],
};



// WEBPACK FOOTER //
// ./src/modules/modal/reactions.js